export enum UiEntityPropertyTypeEnum {
  DATE = 'date',
  CUSTOM = 'custom',
  BOOLEAN = 'boolean',
  STRING = 'string',
  NUMBER = 'number',
  CURRENCY_USD = 'currency_usd'
}
